import {Component, OnInit} from '@angular/core';
import {
    ObjectBaseModeComponent
} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {NavigationItem} from "../../../../../../core/shared/dto/navigation/navigation-item";


@Component({
    selector: 'ei-structure-base',
    template: '',
    standalone: false
})
export class EiStructureBaseComponent extends ObjectBaseModeComponent implements OnInit {


    navigationItems: NavigationItem[] = [
        {
            label: 'Basiskonfiguration',
            action: 'basicConfig',
            tooltip: 'Basiskonfiguration',
            icon: 'fa-solid fa-sliders',
            toggleable: false,
            default: true
        },
        {
            label: 'Felder',
            action: 'fields',
            tooltip: 'Felder',
            icon: 'fa-solid fa-list',
            toggleable: false,
            default: false
        },
        {
            label: 'Suchstrategie-Felder',
            action: 'searchFields',
            tooltip: 'Suchstrategie-Felder',
            icon: 'fa-solid fa-magnifying-glass',
            toggleable: false,
            default: false
        },
        {
            label: 'QL-Abfrageparameter',
            action: 'qlQueryParams',
            tooltip: 'QL-Abfrageparameter',
            icon: 'fa-solid fa-filter',
            toggleable: false,
            default: false
        },
        {
            label: 'Validierungs-QL-Parameter',
            action: 'validationQlParams',
            tooltip: 'Validierungs-QL-Parameter',
            icon: 'fa-solid fa-circle-check',
            toggleable: false,
            default: false
        },
        {
            label: 'Bedingungs-Logik',
            action: 'conditionLogic',
            tooltip: 'Bedingungs-Logik',
            icon: 'fa-solid fa-code-branch',
            toggleable: false,
            default: false
        }
    ];


    ngOnInit() {
        super.ngOnInit();
    }


}
